import { useEffect, useState } from 'react';

export interface LiveStatus {
  isLive: boolean;
  streamerName: string | null;
  listenersCurrent: number;
  nowPlaying: {
    title: string;
    artist: string;
    text: string;
    art: string | null;
  } | null;
}

const POLL_INTERVAL = 10_000;
const API_URL = 'https://stream.radio-suton.de/api/nowplaying/suton_radio';

let cachedStatus: LiveStatus | null = null;
const listeners = new Set<(s: LiveStatus | null) => void>();
let pollIntervalRef: ReturnType<typeof setInterval> | null = null;

const fetchStatus = async () => {
  try {
    const r = await fetch(API_URL);
    if (!r.ok) return;
    const d = await r.json();

    cachedStatus = {
      isLive: d?.live?.is_live ?? false,
      streamerName: d?.live?.streamer_name || null,
      listenersCurrent: d?.listeners?.current ?? 0,
      nowPlaying: d?.now_playing?.song
        ? {
            title: d.now_playing.song.title || '',
            artist: d.now_playing.song.artist || '',
            text: d.now_playing.song.text || '',
            art: d.now_playing.song.art || null,
          }
        : null,
    };

    listeners.forEach((l) => l(cachedStatus));
  } catch {
    // opcioni widget
  }
};

const startPolling = () => {
  if (pollIntervalRef) return;
  void fetchStatus();
  pollIntervalRef = setInterval(() => void fetchStatus(), POLL_INTERVAL);
};

const stopPolling = () => {
  if (pollIntervalRef) {
    clearInterval(pollIntervalRef);
    pollIntervalRef = null;
  }
};

/** Singleton poll — svi konzumeri dijele isto stanje. */
export const useLiveStatus = (): LiveStatus | null => {
  const [status, setStatus] = useState<LiveStatus | null>(cachedStatus);

  useEffect(() => {
    listeners.add(setStatus);
    if (listeners.size === 1) startPolling();

    return () => {
      listeners.delete(setStatus);
      if (listeners.size === 0) stopPolling();
    };
  }, []);

  return status;
};
